import tenant from "@tenant/shared/lib/Http.js"
import { _ } from "core-js"
import Vue from "vue"

/**
 * ======================================================================
 *  STATE
 * ======================================================================
 */

const state = {
    documents: {},
    allDocuments: [],
}

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */

const getters = {

    getDocuments: state => {
        return state.documents
    },

    getAllDocuments: state => {
        return state.allDocuments
    }

}

/**
 * ======================================================================
 *  MUTATIONS
 * ======================================================================
 */

const mutations = {
    setDocuments(state, data) {
        state.documents = data
    },
    setAllDocuments(state, data) {
        state.allDocuments = data
    },
    createDocument(state, data) {
        state.documents.data.push(data)
        state.allDocuments.push(data)
    },
    updateDocument(state, data) {
        state.documents.data = state.documents.data.map(doc => (doc.id == data.id ? { ...doc, ...data } : doc))
        state.allDocuments = state.allDocuments.map(doc => (doc.id == data.id ? { ...doc, ...data } : doc))
    },
    deleteDocument(state, data) {
        let paginatedKey = state.documents.data.findIndex(doc => doc.id === data.id)
        Vue.delete(state.documents.data, paginatedKey);
        let key = state.allDocuments.findIndex(doc => doc.id === data.id)
        Vue.delete(state.allDocuments, key);
    },

}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */
const actions = {

    setDocuments({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            if (_.get(data, 'all', false)) {
                Vue.set(data, 'team', Ambition.currentTeamId())
            }
            tenant.post("/api/document-library/get-documents", data).then(
                response => {
                    if (_.get(data, 'all', false)) {
                        commit("setAllDocuments", response.data)
                    } else {
                        commit("setDocuments", response.data)
                    }
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },

    saveDocument({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            tenant.post("/api/document-library/save-document", data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then((response) => {
                if (data.get('id')) {
                    commit("updateDocument", response.data)
                } else {
                    commit("createDocument", response.data)
                }
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    deleteDocument({ dispatch, commit, state }, data) {
        let isRevert = false
        if (!data.team) isRevert = true
        Vue.set(data, 'currentTeam', Ambition.currentTeamId())
        Vue.set(data, 'isRevert', isRevert)
        return new Promise((resolve, reject) => {
            tenant.post("/api/document-library/delete-document", data).then(
                response => {
                    if (isRevert) {
                        commit("updateDocument", response.data)
                    } else {
                        commit("deleteDocument", response.data)
                    }
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
